import { render, staticRenderFns } from "./FormHeaderRiepilogo.vue?vue&type=template&id=0a4e5146&scoped=true&"
import script from "./FormHeaderRiepilogo.vue?vue&type=script&lang=js&"
export * from "./FormHeaderRiepilogo.vue?vue&type=script&lang=js&"
import style0 from "./FormHeaderRiepilogo.vue?vue&type=style&index=0&id=0a4e5146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e5146",
  null
  
)

export default component.exports